// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.theme-3-custom-editor pre {\n    white-space: pre-line !important;\n}\npre {\n    white-space: pre-line !important;\n}\n.w-editor pre {\n    white-space: pre-line !important;\n}\npre .ql-syntax {\n    white-space: pre-line !important;\n}\n.article-detail-mobile {\n    min-height: 300px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
